import { render, staticRenderFns } from "./settings-side-bar.vue?vue&type=template&id=5950dc7e"
import script from "./settings-side-bar.vue?vue&type=script&lang=js"
export * from "./settings-side-bar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports